import React from 'react';
import { useCountdown } from '../hooks/useCountdown';
export function UrgencyBar() {
  const {
    minutes,
    seconds
  } = useCountdown();
  const pad = (n: number) => n.toString().padStart(2, '0');
  const DigitBox = ({
    value
  }: {
    value: string;
  }) => <span className="inline-flex items-center justify-center w-[24px] h-[28px] bg-black/40 border border-[#B2FF41]/25 rounded-[4px] text-[#B2FF41] font-mono text-sm font-bold" data-id="element-353">
      {value}
    </span>;
  const handleClaim = () => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  return <div className="fixed top-0 left-0 right-0 z-[60] bg-[#062C22]" data-id="element-354">
      <div className="max-w-5xl mx-auto px-4 py-1.5 flex flex-col items-center gap-1" data-id="element-355">
        {/* Line 1: Promo text */}
        <p className="text-white text-[11px] sm:text-xs font-bold tracking-wide text-center leading-tight pt-[5px] pb-[5px]" data-id="element-356">
          OFERTA RELÁMPAGO: Consigue el Paquete Perro Genio con un{' '}
          <span className="urgency-glow text-[#B2FF41] font-extrabold" data-id="element-357">
            80% OFF
          </span>{' '}
          antes de que cierre la promoción.
        </p>

        {/* Line 2: Timer + CTA button */}
        <div className="flex items-center gap-3" data-id="element-358">
          {/* MM : SS timer */}
          <div className="flex items-center gap-[3px]" data-id="element-359">
            <DigitBox value={pad(minutes)[0]} data-id="element-360" />
            <DigitBox value={pad(minutes)[1]} data-id="element-361" />
            <span className="text-[#B2FF41] font-bold text-sm mx-[2px]" style={{
            animation: 'blink 1.2s ease-in-out infinite',
            willChange: 'opacity'
          }} data-id="element-362">
              :
            </span>
            <DigitBox value={pad(seconds)[0]} data-id="element-363" />
            <DigitBox value={pad(seconds)[1]} data-id="element-364" />
          </div>

          {/* Solid pistachio CTA */}
          <button onClick={handleClaim} className="bg-[#B2FF41] text-black font-extrabold text-[10px] sm:text-xs uppercase tracking-wide px-4 py-1.5 rounded-lg hover:brightness-110 active:scale-95 transition-all duration-150 whitespace-nowrap" data-id="element-365">
            ¡OBTÉN UN 80% DE DESCUENTO!
          </button>
        </div>
      </div>
    </div>;
}